import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/_models';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { IGroup } from 'src/app/_models/group';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {
  allGroups: MatTableDataSource<IGroup>
  displayedColumns = ["name", "userPoolId"];
  dialogData: IGroupDialogData
  currentUser: User
  openGroupForm: boolean = false
  groupId: number

  constructor(
    private groupService: UsersAndGroupsService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private datePipe: DatePipe,
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.allGroups.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.allGroups.paginator = this.paginator;
    }
  }


  ngOnInit(): void {
    this.groupService.getAllGroups().subscribe(groups => {
      this.allGroups = new MatTableDataSource(groups.Groups);
      this.allGroups.sort = this.sort;
      this.allGroups.paginator = this.paginator;
    });
  }

  refreshPage() {
    this.ngOnInit();
  }

  createGroup(event) {
    this.openGroupForm = true
    this.dialogData =
    {
      title: "Create Group",
      button: "Create",
      name: "",
      description: "",
    };
  }

  createGroupButton() {
    var group =
    {
      name: this.dialogData.name,
      description: this.dialogData.description
    };
    this.groupService.createGroup(group).subscribe(data => {
      console.log("Success!")
      this.groupService.getAllGroups().subscribe(groups => {
        this.allGroups = new MatTableDataSource(groups);
        this.allGroups.sort = this.sort;
        this.allGroups.paginator = this.paginator;
      })
    },
      error => {
        console.log("Error")
        // alert("ERROR: " + error.error[0])
      }
    )
  }

  // updateGroupButton() {
  //   var updatedGroup =
  //   {
  //     Id: this.groupId,
  //     name: this.dialogData.name,
  //     userPoolId:this.dialogData.userPoolId
  //   };
  //   console.log(updatedGroup)
  //   // this.groupService.updategroup(updatedgroup).subscribe(data => {
  //   //   console.log("Success!")
  //   //   alert("Updated group- " + this.dialogData.name + " successfully!")
  //   //   this.groupService.getgroup().subscribe(groups => {
  //   //     this.allGroups = new MatTableDataSource(groups);
  //   //     this.allGroups.sort = this.sort;
  //   //     this.allGroups.paginator = this.paginator;
  //   //   })
  //   // },
  //   //   error => {
  //   //     console.log("Error")
  //   //     alert("ERROR: " + error.error[0])
  //   //   }  
  //   // )
  // }

  back() {
    this.openGroupForm = false
    this.refreshPage()
  }

  // updateGroup(event, group) {
  //   this.openGroupForm = true
  //   console.log("GroupYYYY", group)
  //     this.dialogData =
  //   {
  //     title: "Update Group",
  //     button: "Update",
  //     name: group.GroupName,
  //     userPoolId:group.UserPoolId
  //   };


  //   //this.groupId = group.id
  //   console.log("#############",this.dialogData)
  // }

  deleteGroup($event, id: number) {
    id
    console.log("DELETE", <number>id)
  }


}

export interface IGroupDialogData {
  title: string;
  button: string;
  name: string;
  description: string;
}
